// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton_CloseButton__2qa-R","CloseButton__Path":"CloseButton_CloseButton__Path__1IOle"};